import { render, staticRenderFns } from "./thirdthird.vue?vue&type=template&id=e0cf81ba&"
import script from "./thirdthird.vue?vue&type=script&lang=js&"
export * from "./thirdthird.vue?vue&type=script&lang=js&"
import style0 from "./thirdthird.vue?vue&type=style&index=0&id=e0cf81ba&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0cf81ba')) {
      api.createRecord('e0cf81ba', component.options)
    } else {
      api.reload('e0cf81ba', component.options)
    }
    module.hot.accept("./thirdthird.vue?vue&type=template&id=e0cf81ba&", function () {
      api.rerender('e0cf81ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/homeComponents/third/thirdthird.vue"
export default component.exports